import { GLOBAL_UNDERSCORE_REGEX, WORD_INITIAL_REGEX } from 'constant/regex';

/**
 * Humanizes field names by replacing underscores with spaces and
 * capitalizing the first letter of each word.
 */
export const humanizeFieldName = (field: string) =>
  field
    .replace(GLOBAL_UNDERSCORE_REGEX, ' ')
    .replace(WORD_INITIAL_REGEX, (char) => char.toUpperCase());
